// auto-generated by Typewriter template _enums.tst from PortCall.Models\Billing\ExportPayload.cs
export enum ExportTargetType { 
    QuickBooks = 0
}

export const ExportTargetTypeDisplayName : { [val : number] : string } = { 
    0: 'QuickBooks'
}

export const ExportTargetTypes : { Id : ExportTargetType, Name : string }[] = [ 
    { Id: ExportTargetType.QuickBooks, Name: 'QuickBooks' }
]

export enum ExportPayloadStatus { 
    New = 0,
    Formatting = 10,
    FormattingFailed = 20,
    Formatted = 99
}

export const ExportPayloadStatusDisplayName : { [val : number] : string } = { 
    0: 'New',
    10: 'Formatting',
    20: 'FormattingFailed',
    99: 'Formatted'
}

export const ExportPayloadStatuses : { Id : ExportPayloadStatus, Name : string }[] = [ 
    { Id: ExportPayloadStatus.New, Name: 'New' },
    { Id: ExportPayloadStatus.Formatting, Name: 'Formatting' },
    { Id: ExportPayloadStatus.FormattingFailed, Name: 'FormattingFailed' },
    { Id: ExportPayloadStatus.Formatted, Name: 'Formatted' }
]



// WEBPACK FOOTER //
// ./server/enums/ExportPayload.ts